import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { CCol, CRow } from "@coreui/react-pro";
import {
  DASHBOARD_OFFER_SLOTS,
  usableOffers,
  useUsableOffers,
} from "../../../api/hooks/useOffers";
import { OfferCard } from "../../../components/common/OfferCard";
import { routePaths } from "../../../routes/route-paths";

/**
 * The dashboard's offers.
 *
 * Capped rather than complete, for the reason the partner offer slot is: the dashboard should read
 * the same whether a customer holds one offer or six. Anything past the cap lives on Your offers,
 * and the link only appears when there is something there to find.
 */
export function OfferSlot() {
  const { t } = useTranslation("offers");
  const offers = usableOffers(useUsableOffers().data);

  // Nothing at all while loading, on error, or when there is nothing to use. An offer is never why
  // someone opened the portal, so it should never be a spinner or an error box on the dashboard.
  if (offers.length === 0) return null;

  const shown = offers.slice(0, DASHBOARD_OFFER_SLOTS);

  return (
    <div className="mt-4 mb-4">
      <div className="d-flex align-items-center gap-3 mb-2">
        <div className="text-uppercase small fw-bold text-body-secondary">{t("slot.title")}</div>
        {offers.length > shown.length && (
          <Link to={routePaths.offers} className="ms-auto btn btn-outline-primary btn-sm">
            {t("slot.seeAll", { count: offers.length })}
          </Link>
        )}
      </div>
      <CRow xs={{ gutter: 4 }}>
        {shown.map((offer) => (
          <CCol key={offer.id} md={6}>
            <OfferCard offer={offer} className="h-100 mb-0" />
          </CCol>
        ))}
      </CRow>
    </div>
  );
}
